import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { Dialog } from '../Dialog'
import { Field } from '../Field'
import { schoolApi } from '../../api/school'
import { ApiError } from '../../api/client'

/** Диалог создания школы — после успеха перезагружает страницу. */
export function CreateSchoolDialog({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [shortName, setShortName] = useState('')
  const [region, setRegion] = useState('')

  const mut = useMutation({
    mutationFn: () =>
      schoolApi.createSchool({
        name: name.trim(),
        shortName: shortName.trim() || undefined,
        region: region.trim() || undefined,
      }),
    onSuccess: () => window.location.reload(),
  })

  return (
    <Dialog title={t('createSchoolDialog.title')} onClose={onClose}>
      <Field label={t('createSchoolDialog.fullName')}>
        <input
          className="input-field"
          placeholder={t('createSchoolDialog.fullNamePlaceholder')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          autoFocus
        />
      </Field>
      <Field label={t('createSchoolDialog.shortName')}>
        <input
          className="input-field"
          placeholder={t('createSchoolDialog.shortNamePlaceholder')}
          value={shortName}
          onChange={(e) => setShortName(e.target.value)}
        />
      </Field>
      <Field label={t('createSchoolDialog.region')}>
        <input
          className="input-field"
          placeholder={t('createSchoolDialog.regionPlaceholder')}
          value={region}
          onChange={(e) => setRegion(e.target.value)}
        />
      </Field>
      {mut.error && <div className="text-sm text-red-600 mb-3">{(mut.error as ApiError).message}</div>}
      <div className="flex gap-2 justify-end mt-3">
        <button onClick={onClose} className="btn-outline text-sm">{t('common.cancel')}</button>
        <button
          onClick={() => mut.mutate()}
          disabled={mut.isPending || !name.trim()}
          className="btn-primary text-sm"
        >
          {mut.isPending ? '…' : t('createSchoolDialog.create')}
        </button>
      </div>
    </Dialog>
  )
}
